'use client';

import { useCallback } from 'react';

import { useCareStateCommands, useCareStateDomain } from '@/entities/care-state-domain';
import { TextFieldTool, useAgentTweakable } from '@/features/copilot/agent-tweakable';

/**
 * Exposes the patient's root care-state note to the copilot as a single
 * `careNote` text field. Symmetric with the per-request `note:<id>`
 * tweakables emitted by `RequestListCard`. Renders nothing — the note is
 * displayed read-only inside the Snapshot overlay and edited solely
 * through this agent surface.
 */
export function PatientCareNoteAgentBinding() {
  const { careState } = useCareStateDomain();
  const commands = useCareStateCommands();

  const currentNote = careState?.patients.find((p) => p.id === 'root')?.note.value ?? '';

  const onAgentSetCareNote = useCallback(
    (next: string) => {
      commands.execute({ type: 'patient.setNote', note: next }, { actor: 'copilot' });
      return { saved: true, noteLength: next.length };
    },
    [commands]
  );

  useAgentTweakable(TextFieldTool, 'careNote', currentNote, onAgentSetCareNote);
  return null;
}
